/**
 * Example of a Word-generated empty paragraph:
 * <p class="MsoNormal">
 *   <o:p>&nbsp;</o:p>
 * </p>
 */

import { traverseHtmlElements } from '@flow/libs/html/utils/traverseHtmlElements';

import { NO_BREAK_SPACE } from '@flow/libs/html/constants';

const isHtmlOpEmpty = (element: Element): boolean =>
  element.nodeName === 'O:P' && element.textContent === NO_BREAK_SPACE;

// `firstElementChild` returns the first child Node of type Element,
// ignoring any text nodes (e.g. whitespace or line breaks).
const isHtmlElementEmpty = (element: Element): boolean =>
  element.children.length === 1 &&
  element.firstElementChild !== null &&
  (isHtmlOpEmpty(element.firstElementChild) || isHtmlElementEmpty(element.firstElementChild));

/** Remove paragraph innerHTML if its child is 'O:P' with NO_BREAK_SPACE. */
export const cleanDocxEmptyParagraphs = (rootNode: Node): void => {
  traverseHtmlElements(rootNode, (element) => {
    if (element.tagName === 'P' && isHtmlElementEmpty(element)) {
      element.innerHTML = '';
    }

    return true;
  });
};
